var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDirectApply = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7616FF",
  d: "M4.4 2.4A1.6 1.6 0 0 0 2.8 4v17.182a.419.419 0 0 0 .645.353l1.714-1.099a1.6 1.6 0 0 1 1.727 0l1.555.998a1.06 1.06 0 0 0 1.14 0l1.556-.998a1.6 1.6 0 0 1 1.727 0l1.556.998a1.06 1.06 0 0 0 1.14 0l1.555-.998a1.6 1.6 0 0 1 1.727 0l1.713 1.098a.42.42 0 0 0 .646-.352V4a1.6 1.6 0 0 0-1.6-1.6z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "m16.71 10.961-3.393-3.525a.767.767 0 0 0-1.027-.054.64.64 0 0 0-.058.953l2.31 2.4H7.268c-.402 0-.728.302-.728.675s.325.675.728.675h7.29l-2.347 2.438a.64.64 0 0 0 .058.953.76.76 0 0 0 .484.171c.2 0 .4-.076.544-.225l3.393-3.525a.7.7 0 0 0 .111-.154.636.636 0 0 0-.09-.78z"
})));
export default SvgDirectApply;